import React from 'react';
import { useTranslation } from 'react-i18next';

const GuessConfirmationModal = ({ isOpen, candidate, onConfirm, onCancel }) => {
    const { t } = useTranslation();

    if (!isOpen || !candidate) return null;

    return (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[100] flex items-center justify-center p-4 animate-in fade-in duration-200">
            <div className="bg-gray-900 border-4 border-yellow-600 rounded-3xl shadow-2xl w-full max-w-sm relative overflow-hidden transform transition-all scale-100 animate-in zoom-in-95">
                {/* Header */}
                <div className="bg-yellow-600/20 p-4 border-b border-yellow-600/50 flex flex-col items-center">
                    <h3 className="text-2xl font-black text-yellow-500 tracking-wider uppercase drop-shadow-md">
                        {t('GuessWho.modal.title', 'CONFIRM GUESS?')}
                    </h3>
                    <p className="text-xs text-yellow-200/80 font-mono mt-1">
                        {t('GuessWho.modal.warning', 'If you are wrong, you lose your turn!')}
                    </p>
                </div>

                {/* Body */}
                <div className="p-6 flex flex-col items-center">
                    <div className="relative mb-6">
                        <div className="absolute inset-0 bg-yellow-500 blur-lg opacity-20 rounded-full"></div>
                        <img
                            src={candidate.img}
                            alt={candidate.name}
                            className="w-32 h-32 rounded-full border-4 border-yellow-500 shadow-xl object-cover relative z-10 bg-gray-800"
                        />
                        <div className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 bg-yellow-600 text-black text-xs px-3 py-1 rounded-full font-black uppercase tracking-widest shadow-lg z-20 whitespace-nowrap">
                            {candidate.name}
                        </div>
                    </div>

                    <p className="text-gray-300 text-center text-sm mb-6 px-4">
                        {t('GuessWho.modal.question', 'Are you sure this is the secret character?')}
                    </p>

                    <div className="flex gap-3 w-full">
                        <button
                            onClick={onCancel}
                            className="flex-1 py-3 rounded-xl font-bold text-gray-400 hover:text-white bg-gray-800 hover:bg-gray-700 transition-all border border-gray-700"
                        >
                            {t('Common.cancel', 'CANCEL')}
                        </button>
                        <button
                            onClick={onConfirm}
                            className="flex-1 py-3 rounded-xl font-bold text-black bg-yellow-500 hover:bg-yellow-400 transition-all shadow-lg hover:shadow-yellow-500/20 active:scale-95"
                        >
                            {t('Common.confirm', 'YES, GUESS!')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuessConfirmationModal;
